import React, { FC, useEffect, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import './style.scss';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import QuestionBox from 'src/components/molecules/content/QuestionBox';
import {
  contentModalDep2ViewStore,
  errorModalViewStore,
  loadingModalViewStore,
} from 'src/store/modal';
import { savingsDataStore } from 'src/store/housingfunds/savings';
import { fetchUpdateHouseSave, fetchSurveyUpdate } from 'src/fetch/stepC/houseSaving';
import { getMemberInfo } from 'src/utils/common';

interface Props {
  viewType?: string;
}

const Spouse: FC<Props> = ({ viewType }) => {
  const queStyle = { width: '400px' };
  const queSet = {
    question: [
      {
        idx: 0,
        status: 'this',
        confirm: '',
        set: {
          question: '근로소득이 있습니까?',
          style: queStyle,
          desc: {
            style: {},
            data: [
              {
                text: <div className="_text">일용근로자는 '아니오' 선택</div>,
              },
            ],
          },
        },
      },
      {
        idx: 1,
        status: 'ready',
        confirm: '',
        set: {
          question: '총급여액이 7천만원 이하입니까?',
          style: queStyle,
          desc: {
            style: {},
            desc: {
              style: {},
              data: [],
            },
          },
        },
      },
      {
        idx: 2,
        status: 'ready',
        set: {
          question: '과세기간 종료일(12.31.) 현재 세대주 및 세대주의 배우자 인가요?',
          style: queStyle,
          desc: {
            style: {},
            data: [],
          },
        },
      },
      {
        idx: 3,
        status: 'ready',
        set: {
          question: '가입하신 저축을 선택하세요',
          style: queStyle,
          desc: {
            style: {},
            dat: [
              {
                text: <div className="_text">1. 주택청약 종합저축(네 클릭)</div>,
              },
              {
                text: <div className="_text">2. 청약 저축(아니오 클릭)</div>,
              },
            ],
          },
        },
      },
      {
        idx: 4,
        status: 'ready',
        set: {
          question:
            '과세기간 (1.1. - 12.31.)중 본인, 배우자, 주민등록등본 상 세대원이 주택을 소유한 적이 없나요?',
          style: queStyle,
          desc: {
            style: {},
            data: [],
          },
        },
      },
      {
        idx: 5,
        status: 'ready',
        set: {
          question: '주택당첨 이외의 사유로 주택청약종합저축등을 중도 해지 하였나요?',
          style: queStyle,
          desc: {
            style: {},
            data: [],
          },
        },
      },
      {
        idx: 6,
        status: 'ready',
        set: {
          question: '공제과세기간 다음연도 2월말까지 저축기관에 무주택확인서를 제출하였나요?',
          style: queStyle,
          desc: {
            style: {},
            data: [
              {
                text: (
                  <div className="_text">
                    (단, 무주택확인서는 1회 제출에 한하며 매년 제출할 필요는 없음)
                  </div>
                ),
              },
            ],
          },
        },
      },
    ],
    answer: {
      status: 'ready',
      set: {
        title: '주택공제를 받을 수 있습니다.',
        status: 'yes',
        desc: {
          data: [
            {
              // text: (
              //   <div className="_text">이때, 총 급여액은 비과세 소득을 제외한 금액을 말합니다.</div>
              // ),
            },
          ],
        },
      },
    },
  };

  const [queState, setQueState] = useState({ set: queSet.question });
  const [awsState, setAwsState] = useState({ set: queSet.answer });

  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  const setContentModalDep2State = contentModalDep2ViewStore((state: any) => state.set);
  const userInfoData: any = getMemberInfo();

  const savingList = savingsDataStore((state: any) => state.result).data || [];
  const bindStoreParam = savingsDataStore((state: any) => state.param);
  const bindStoreBindParam = savingsDataStore((state: any) => state.bindParam);

  const confirmEvent = async () => {
    const answerStatus = awsState.set.set.status === 'no' ? 'X' : 'Y';
    for (const item of savingList) {
      const param = {
        // ...item,
        in_data_seqid: item.in_data_seqid,
        house_type: 'savings',
        acct_year: userInfoData.acct_year,
        co_cd: userInfoData.co_cd,
        co_id: userInfoData.co_id,
        question_status: answerStatus,
      };
      await fetchSurveyUpdate(param, queryClient, errorModalState, loadingState, () => {});
    }
    const initialSeq = bindStoreParam.initialSeq || 0;
    bindStoreBindParam({ initialSeq: initialSeq + 1 });
    setContentModalDep2State({ active: '', content: null });
  };

  useEffect(() => {
    const queEndStatus = queState.set.filter((item: any) => item.status !== 'end');
    const queConfirmStatus = queState.set.filter((item: any) => item.confirm === 'yes');

    if (queEndStatus.length === 0) {
      awsState.set.status = 'end';
      if (queState.set.length !== queConfirmStatus.length) {
        awsState.set.set.title = '주택공제를 받을 수 없습니다.';
        awsState.set.set.status = 'no';
      } else {
        awsState.set.set.title = '주택공제를 받을 수 있습니다.';
        awsState.set.set.status = 'yes';
      }

      setAwsState({ set: awsState.set });
    } else {
      awsState.set.status = 'ready';
      setAwsState({ set: awsState.set });
    }
  }, [queState]);

  return (
    <div className="_spouse_question_div">
      <div className="que_box">
        <QuestionBox
          queSet={queSet}
          queState={queState}
          setQueState={setQueState}
          awsState={awsState}
          setAwsState={setAwsState}
        />
      </div>
      {awsState.set.status === 'end' ? (
        <div className="_confirm_btn_div">
          <DefaultButton
            text="확인"
            clickEvent={e => confirmEvent()}
            styleDef={{ fontSize: '13px', width: '210px', height: '38px' }}
            type="type5"
          />
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Spouse;
